import { AnalyticsPlugin } from 'analytics';

import { TrackingPixelVendor } from '../enums/TrackingPixelVendor';
import { createTrackingPixelPlugin } from '../functions/createTrackingPixelPlugin';
import { ensureVendorScript } from '../functions/ensureVendorScript';
import { TradeDeskEventParams } from '../types/TradeDeskEventParams';
import { TradeDeskWindow } from '../types/TradeDeskWindow';

const UP_LOADER_SRC = 'https://js.adsrvr.org/up_loader.3.0.0.js';

const ttdConversionEvents: (
  command: 'event' | 'init',
  params: TradeDeskEventParams,
) => void = function (): void {
  // eslint-disable-next-line prefer-rest-params -- up_loader reads arguments objects, exactly as TTD's own snippet pushes them
  (window as TradeDeskWindow).ttdConversionEventsLayer.push(arguments);
};

export const tradeDeskPlugin = (): AnalyticsPlugin => {
  // init creates a fixed-id cookie-sync iframe, so it runs once per advertiser per page load
  const initialisedAdvertisers = new Set<string>();

  return createTrackingPixelPlugin(
    TrackingPixelVendor.TRADE_DESK,
    (pixels): void => {
      const tradeDeskWindow = window as TradeDeskWindow;

      tradeDeskWindow.ttdConversionEventsLayer =
        tradeDeskWindow.ttdConversionEventsLayer || [];

      // up_loader drains the layer when it loads and replaces its push
      ensureVendorScript(UP_LOADER_SRC);

      pixels.forEach(({ accountId, pixelIds }): void => {
        const params: TradeDeskEventParams = {
          advertiserId: accountId,
          pixelIds,
        };

        if (!initialisedAdvertisers.has(accountId)) {
          ttdConversionEvents('init', params);
          initialisedAdvertisers.add(accountId);
        }

        ttdConversionEvents('event', params);
      });
    },
  );
};
